import { Component, Input, OnInit } from '@angular/core';
import { AddressService } from 'src/app/services/address.service';
import { ToastController } from '@ionic/angular';

@Component({
    selector: 'app-address-fragment',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss'],
    standalone: false
})
export class AddressComponent implements OnInit {

  @Input() userId;

  public addressForm;

  constructor(private addressService: AddressService,
              private toastController: ToastController) { }

  ngOnInit() {
    this.addressForm = this.addressService.$editing;
  }

  async updateAddress() {
    if (this.addressService.$editing.value.valid) {
      const formData = this.addressService.createFormData(this.addressService.$editing.value);
      formData.append('user_id', this.userId);
      this.addressService.post(formData).subscribe(async () => { 
        this.addressService.load('all', this.addressService.$editing.value.id);
      });
    } else {
      const toast = await this.toastController.create({
        header: 'Info',
        message: 'Incomplete address data could not be saved.',
        duration: 4000,
        position: 'bottom',
      });
      await toast.present();
    }
  }
}
